import { z } from "zod";


export const goodslineSchema = z.object({
    lineNo: z.number().optional(),
    type: z.string().max(20),
    description: z.string().max(40, { message: 'validation.invalidMaxLength' }).optional(),
    quantity: z.number().min(1),
    weight: z.number(),
    netWeight: z.number().optional(),
    length: z.number().optional(),
    width: z.number().optional(),
    height: z.number().optional(),
    volume: z.number().optional(),
    loadmeter: z.number().optional(),
    trackingNumbers: z.array(z.string()).readonly().nullish(),
});

export type GoodslineType = z.infer<typeof goodslineSchema>;